import React, { useState, useEffect } from "react";
import { Container, Title } from "./styles";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import InputEdit from "../../components/InputEdit";
import RedButton from "../../components/RedButton";
import api from "../../services/api";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate, useParams } from "react-router-dom";

const EditarModeloSaida = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [nomeModeloSaida, setNomeModeloSaida] = useState("");

  useEffect(() => {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("token");

    if (!token || role !== "ADMIN") {
      navigate("/login");
    }

    api.get(`/outputDevices/${id}`).then((response) => {
      if (response.data) {
        setNomeModeloSaida(response.data.nome || "");
      }
    });
  }, [navigate, id]);

  const handleDescricaoModeloSaida = (event) => {
    setNomeModeloSaida(event.target.value);
  };

  const formSubmit = (event) => {
    event.preventDefault();

    const data = {
      nome: nomeModeloSaida,
    };

    api
      .put(`/outputDevices/${id}`, data)
      .then((response) => {
        toast.success("Modeçp de venda alterado com sucesso!");
        navigate("/menuModeloSaida");
      })
      .catch((error) => {
        console.error("Erro: ", error);
        if (error.response) {
          if (error.response.status === 404 || error.response.status === 400) {
            toast.warning(`${error.response.data.error}`);
          } else {
            toast.error(`${error.response.data.error}`);
          }
        } else {
          toast.error("Erro interno de servidor. Por favor, tente novamente!");
        }
      });
  };

  return (
    <Container>
      <MDBRow style={{ width: "100%", justifyContent: "center" }}>
        <MDBCol xg={6} lg={6} md={8} sm={12}>
          <form onSubmit={formSubmit}>
            <Title className="text-center">
              <h3>Editar {nomeModeloSaida}</h3>
            </Title>

            <MDBRow>
              <MDBCol md={12} className="text-start">
                <label>Nome</label>
                <InputEdit
                  value={nomeModeloSaida}
                  onChange={(event) => handleDescricaoModeloSaida(event)}
                  password={false}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <RedButton onClick={() => navigate("/menuModeloSaida")}>
                <strong>Voltar</strong>
              </RedButton>
              <RedButton onClick={formSubmit}>
                <strong>confirmar edição</strong>
              </RedButton>
            </MDBRow>
          </form>
        </MDBCol>
      </MDBRow>
    </Container>
  );
};

export default EditarModeloSaida;
